<template>
    <div v-if="survey" class="tw-bg-gray-100 tw-flex tw-flex-col" id="survey-details">
        <div class="header" v-if="$route.name !== 'surveys-preview'">
            <div class="breadcrumbs" id="breadcrumbs">
                <router-link class="breadcrumb-link" to="/surveys/dashboard">Bookblock HUB Surveys</router-link> &gt;
                <router-link class="breadcrumb-link" :to="'/surveys/' + survey.id">{{ survey.name }}</router-link>
            </div>
            <h3>{{ survey.name }}</h3>
            <div class="ws-large-tab-menu">
                <router-link :to="{name: 'surveys-details', params: {survey_id: survey.id} }">
                    Summary
                </router-link>
                <router-link :to="{name: 'surveys-details-questions', params: {survey_id: survey.id} }">
                    Questions
                </router-link>
                <router-link :to="{name: 'surveys-details-responses', params: {survey_id: survey.id} }" class="include-children">
                    Responses
                </router-link>
                <router-link :to="{name: 'surveys-details-results', params: {survey_id: survey.id} }">
                    Results
                </router-link>
            </div>
        </div>
        <router-view class="survey-detail tw-flex-grow"/>
    </div>
    <div class="tw-text-lg" v-else>
        Loading....
    </div>
</template>

<script>

export default {
    name: 'SurveyDetails',
    data() {
        return {}
    },
    computed: {
        survey() {
            return this.$store.getters["surveys/selected"];
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.fetchSurvey(to.params.survey_id);
        next();
    },
    created() {
        this.fetchSurvey(this.$route.params.survey_id)
    },
    methods: {
        async fetchSurvey(id) {
            if (this.$store.state.surveys.selected !== id) {
                this.$store.commit('surveys/setSelected', id);
                await this.$store.dispatch('surveys/getById', {id});
            }
        },
    },
}
</script>
